import axios from "axios";
import { Util } from "../common/util/util";

export const instanceAdmin = axios.create({
  baseURL: "http://localhost:3000/api/admin",
  withCredentials: true,
  headers: {
    "API-KEY": "a9b36abe-d689-4dc1-9b92-adeaba26d689",
    token:
      process.env.REACT_APP_SECURITY_TOKEN ||
      "99d2ce7b16e8a43aa102f6216e19e61b",
  },
});

/*export const instance = axios.create({
  baseURL: process.env.REACT_APP_HOST,
  headers: {
    token:
      process.env.REACT_APP_SECURITY_TOKEN ||
      "99d2ce7b16e8a43aa102f6216e19e61b",
  },
});*/

export const instance = axios.create({
  method: "get",
  baseURL: process.env.REACT_APP_BASE_URL_API,
  url: "api/articles",
  headers: {
    token: Util.getTokenSecurity(),
  }
});

export interface IErrors {
  error: boolean;
  message: string;
}
export enum ResultCodes {
  Success = 0,
  Error = 4,
}
